const IssuerManagerActionTypes = {
    FETCH_ISSUERS_LIST_START: "FETCH_ISSUERS_LIST_START",
    FETCH_ISSUERS_LIST_SUCCESS: "FETCH_ISSUERS_LIST_SUCCESS",
    FETCH_ISSUERS_LIST_FAILURE: "FETCH_ISSUERS_LIST_FAILURE",
};

export default IssuerManagerActionTypes;
